module.exports = __webpack_public_path__ + "static/media/point_system_p.bb781ff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/point_system_p.jpg
// module id = 362
// module chunks = 0